import React from 'react';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { Routes, Route, Link, NavLink } from 'react-router-dom';
import Home from '../pages/Home';
import News from '../pages/News';
import Tele from '../pages/Tele';
import Notfoundpage from '../pages/Notfoundpage';
import SiteButton from './Ui/button/siteButton';
import logo from '../image/logo.png';
import classes from './header.module.css';
import Tower from '../pages/Tower';
import Smart from '../pages/Smart';
import Dicecell from '../pages/Dicecell';
import Xtower from '../pages/Xtower';
import Opt from '../pages/Opt';
import MicroOTN from '../pages/modules/microOTN';
import LmWDM from '../pages/modules/lmWDM';
import LmOTN from '../pages/modules/lmOTN';
import LmRoadm from '../pages/modules/lmRoadm';
import Rele from '../pages/Rele';
import Alfoplus2 from '../pages/modules/alfoplus2';
import Alfoplus80 from '../pages/modules/alfoplus80';
import Ags20 from '../pages/modules/ags20';
import Nms5 from '../pages/modules/nms5';
import Acts from '../pages/Acts';

const Header = () => {
    return (
        <>
            <Navbar collapseOnSelect expand="md" className={classes.navbarTop} fixed="top">
                <Container fluid="fluid">
                    <Link to="/home">
                        <img 
                            src={logo}
                            width="90"
                            className="d-inline-block align-top"
                            alt="logo"
                        />
                    </Link>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
                    <Navbar.Collapse className={classes.navCollapse}>
                        <Nav>
                            <NavLink to="/home" className={classes.navLink}>Главная</NavLink>
                            <NavDropdown title="Продукты и решения" className={classes.navDrop_down}>
                                <NavLink to="/tower" className={classes.navLink1}>Башенные конструкции</NavLink>
                                <NavLink to="/tele" className={classes.navLink1}>Телекомуникационные решения</NavLink>
                            </NavDropdown>
                            <NavLink to="/news" className={classes.navLink}>Новости</NavLink>
                            <SiteButton>Связаться с нами</SiteButton>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <Routes>
                <Route path="/" element={<Home />}/>
                <Route path="/home" element={<Home/>} />
                <Route path="/tele" element={<Tele/>} />
                <Route path="/tower" element={<Tower />} />
                <Route path="/news" element={<News/>} />
                <Route path="/dicecell" element={<Dicecell />} />
                <Route path="/xtower" element={<Xtower />} />
                <Route path="/smart" element={<Smart />} />
                <Route path="/opt" element={<Opt />} />
                <Route path="/rele" element={<Rele />} />
                <Route path="/microotn" element={<MicroOTN />} />
                <Route path="/lmwdm" element={<LmWDM />} />
                <Route path="/lmwotn" element={<LmOTN />} />
                <Route path="/lmroadm" element={<LmRoadm />} />
                <Route path="/alfoplus2" element={<Alfoplus2 />} />
                <Route path="/alfoplus80" element={<Alfoplus80 />} />
                <Route path="/ags20" element={<Ags20 />} />
                <Route path="/nms5" element={<Nms5 />} />
                <Route path="/acts" element={<Acts />} />
                <Route path="*" element={<Notfoundpage/>} />
            </Routes>
        </>
    )
}

export default Header;